module.exports = __webpack_public_path__ + "static/media/details-bnx-account-ss.8337bbde.png";